import type { ProductGridConfig } from "@/types/dragon-tiles";

import { buildProductGridConfigSlice } from "@/frames/service";

/**
 * Builds one `product_grids` entry for SMS/RCS/MMS frame variants.
 * `maxProducts` is always derived from the authored content (never inherited
 * from a stored config), so deleting product copy brings the request ceiling
 * back down.
 */
export function buildTextProductGridConfig(
  model: string,
  maxProducts: number,
): ProductGridConfig {
  return buildProductGridConfigSlice({ key: "0", items: model, maxProducts })[
    "0"
  ];
}
